import {
  init_react_import
} from "./chunk-65BGW52G.mjs";

// mixins/text.ts
init_react_import();
import { Typography } from "@persona-id/design-tokens";
import { css } from "styled-components";
var fontFamilyMixin = css`
  font-family: ${({ theme }) => theme.text.fontFamily.base};
`;
var displayMixins = {
  lg: css`
    ${Typography.DisplayLarge};
    margin: 0;
  `,
  md: css`
    ${Typography.DisplayMedium};
    margin: 0;
  `,
  sm: css`
    ${Typography.DisplaySmall};
    margin: 0;
  `
};
var headingMixins = {
  lg: css`
    ${Typography.HeadingLarge};
    margin: 0;
  `,
  md: css`
    ${Typography.HeadingMedium};
    margin: 0;
  `,
  sm: css`
    ${Typography.HeadingSmall};
    margin: 0;
  `
};
var paragraphMixins = {
  lg: css`
    ${Typography.TextLarge};
    margin: 0;
  `,
  lgBold: css`
    ${Typography.TextLargeBold};
    margin: 0;
  `,
  lgLight: css`
    ${Typography.TextLargeLight};
    margin: 0;
  `,
  md: css`
    ${Typography.TextMedium};
    margin: 0;
  `,
  mdBold: css`
    ${Typography.TextMediumBold};
    margin: 0;
  `,
  mdLight: css`
    ${Typography.TextMediumLight};
    margin: 0;
  `,
  mdLink: css`
    ${Typography.TextMediumLink};
    margin: 0;
  `,
  sm: css`
    ${Typography.TextSmall};
    margin: 0;
  `,
  smLink: css`
    ${Typography.TextSmallLink};
    margin: 0;
  `,
  xs: css`
    ${Typography.TextExtraSmall};
    margin: 0;
  `
};

export {
  fontFamilyMixin,
  displayMixins,
  headingMixins,
  paragraphMixins
};
//# sourceMappingURL=chunk-6FXAQBW6.mjs.map